import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Personnel_Details_Form.css";
import { Link } from "react-router-dom";
import Select from "react-select";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import {
  Create,
  GetAll,
  GetByUserId,
  Update,
} from "../../../../../../../features/admin/quality_management/resource_requirement/training_details/Slice";
import {
  allDesignation,
  allQualification,
  allSpecialization,
  allRelevant_Training,
  allUsers,
  AllTrainingField,
  AllTrainingStatus,
  AllTrainingType,
} from "../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm, useWatch } from "react-hook-form";
import { GETAuthLogin } from "../../../../../../../features/auth/Slice";
import { GetAppSetup } from "../../../../../../../features/admin/Profile/Slice";

function Training_Field_Form({ handleClose }) {
  const dispatch = useDispatch();
  const all_training_field = useSelector(
    (state) => state.common.all_training_field,
  );
  const all_training_status = useSelector(
    (state) => state.common.all_training_status,
  );

  const all_training_type = useSelector(
    (state) => state.common.all_training_type,
  );

  useEffect(() => {
    dispatch(AllTrainingField());
    dispatch(AllTrainingStatus());
    dispatch(AllTrainingType());
  }, [dispatch]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    trigger,
    reset,
    control,
  } = useForm({});

  const [success, setSuccess] = useState(false);

  const selectedUserId = useWatch({
    control,
    name: "user_id",
  });

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      formData.append("training_field_id", data.training_field_id);
      formData.append("type_of_training_id", data.type_of_training_id);
      formData.append("duration", data.duration);

      let res;

      res = await dispatch(Create(formData));

      // ✅ SUCCESS (same style as old code)
      if (res?.meta?.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        reset();

        setSuccess(true);
      } else {
        // setShowError(res?.payload?.errors || {});
      }
    } catch (error) {
      console.error("Personnel submit error:", error);
    }
  };
  const appsetup = useSelector((state) => state.profile.appsetup_data);
    useEffect(() => {
      dispatch(GetAppSetup());
    }, [dispatch]);

  return (
    <>
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <div className="note_text_holder">
            <p className="red_text">
              If you require training, please Raise a Training Request through
              the system.
            </p>
          </div>

          <div className="row">
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Training Fields</Form.Label>
                <Controller
                  name="training_field_id"
                  control={control}
                  rules={{ required: "Training Fields is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_training_field}
                      value={
                        all_training_field?.find(
                          (o) => o.value === field.value,
                        ) || null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.training_field_id && (
                  <Form.Text className="text-danger">
                    {errors.training_field_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Type Of Training</Form.Label>
                <Controller
                  name="type_of_training_id"
                  control={control}
                  rules={{ required: "Type Of Training is required" }}
                  render={({ field }) => (
                    <Select
                      options={all_training_type}
                      value={
                        all_training_type?.find(
                          (o) => o.value === field.value,
                        ) || null
                      }
                      onChange={(e) => field.onChange(e?.value || null)}
                    />
                  )}
                />
                {errors.type_of_training_id && (
                  <Form.Text className="text-danger">
                    {errors.type_of_training_id.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Duration Of Training</Form.Label>
                <Form.Control
                  placeholder="Experience"
                  {...register("duration", {
                    required: "Duration is required",
                  })}
                  onKeyDown={(e) => {
                    const value = e.target.value;

                    // Allow control keys
                    if (
                      [
                        "Backspace",
                        "Delete",
                        "Tab",
                        "ArrowLeft",
                        "ArrowRight",
                      ].includes(e.key)
                    ) {
                      return;
                    }

                    // Allow numbers
                    if (/^[0-9]$/.test(e.key)) {
                      return;
                    }

                    // Allow ONE decimal point
                    if (e.key === "." && !value.includes(".")) {
                      return;
                    }

                    // Block everything else
                    e.preventDefault();
                  }}
                />
                {errors.duration && (
                  <small className="text-danger">
                    {errors.duration.message}
                  </small>
                )}
              </Form.Group>
            </div>

            <div className="col-md-12">
              <Form.Group className="form_group">
                <Form.Label>Status Of Training:</Form.Label>
              </Form.Group>
            </div>

            <div className="col-md-12">
              <div className="note_text_holder">
                <p>
                  For detailed information about our training programs, feel
                  free to visit us:
                  <Link
                    // to="http://nlcjsf.nlcindia.com:8080/LDC/faces/login.xhtml"
                    to={appsetup?.personal_link}
                    target="_blank"
                    rel="noreferrer"
                    className="ms-1 green_text"
                  >
                   {appsetup?.personal_link}
                  </Link>
                </p>
              </div>
            </div>
          </div>

          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button
                  type="button"
                  className="permission_btn No_btn"
                  onClick={() => reset()}
                >
                  Reset
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Training_Field_Form;
